import { PlayerContact } from "@sazka/utils/models/contact";
import { NgSession } from "./model/ng-fw";

export function ngSessionToContact(session: NgSession): PlayerContact {
    return {
        birthday: session.Birthday,
        city: session.City,
        firstName: session.PlayerName,
        lastName: session.PlayerLastName,
        email: session.PlayerEmail,
        phoneNumber: session.PlayerCellphone,
        vipLevel: session.PlayerVipLevel,
        registrationDate: session.PlayerRegistrationDate,
        countryCode: session.CountryCode,
    };
}
